import { type Cluster } from '@/packages/query-state/shared/types/clusters/ClustersResponse';

import { type IViewedClustersService } from '../IViewedClustersService';

export const LOCAL_STORAGE_KEY = 'search-frontend.viewedClusters';
const VIEWED_CLUSTERS_LIMIT = 1000;

export class ViewedClustersService implements IViewedClustersService {
  public storeViewedClustersIds(clustersIds: Array<Cluster['id']>): void {
    const viewedClusters = this.viewedClusters;

    if (viewedClusters.length >= VIEWED_CLUSTERS_LIMIT) {
      viewedClusters.shift();
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, [...viewedClusters, ...clustersIds].join(','));
  }

  public getIsClusterViewed(clusterId: Cluster['id']): boolean {
    return this.viewedClusters.includes(clusterId);
  }

  private get viewedClusters(): Array<Cluster['id']> {
    return localStorage.getItem(LOCAL_STORAGE_KEY)?.split(',') || [];
  }
}
